import { Component } from "react";
import { Nav } from "react-bootstrap";
import ChevronListItem from "@/components/react/ChevronListItem";
import * as t from "@/lib/backend/manufacturing2.generated.types";

type Props = {
    filter: string;
    selected: t.IPlantData | null;
    plants: t.IPlantData[];
    handlePlantClick: (plant: t.IPlantData) => void;
};

class PlantsList extends Component<Props> {
    handlePlantClick(plant: t.IPlantData) {
        // Ignore clicks for currently selected plant.
        if (plant === this.props.selected) {
            return;
        }

        // Handle parent's click events.
        this.props.handlePlantClick(plant);
    }

    includes(needle: string, plant: t.IPlantData): boolean {
        needle = needle.toLowerCase();
        if (needle.length === 0) return true;
        if (plant.title.toLowerCase().indexOf(needle) > -1) return true;
        if (plant.external_id.toLowerCase().indexOf(needle) > -1) return true;
        if (plant.uuid.toLowerCase().indexOf(needle) > -1) return true;

        // Search tag keys and values
        let tagsSearch = false;
        if (plant.tags !== undefined) {
            Object.keys(plant.tags).forEach(el => {
                // Comparing values
                if (String(plant.tags![el]).toLowerCase().indexOf(needle) > -1) {
                    tagsSearch = true;
                }
                // Comparing keys
                if (el.toLowerCase().indexOf(needle) > -1) {
                    tagsSearch = true;
                }
            });
        }
        return tagsSearch;
    }

    render() {
        const plantsList = this.props.plants.map(plant => {
            if (!this.includes(this.props.filter, plant)) return null;

            const is_active = this.props.selected === plant;
            return (
                <ChevronListItem
                    key={plant.uuid}
                    text={plant.title}
                    subtext={plant.external_id}
                    onClick={() => this.handlePlantClick(plant)}
                    is_active={is_active}
                />
            );
        });

        return (
            <Nav variant="tabs">
                <div className="nav-tabs-parent">{plantsList}</div>
            </Nav>
        );
    }
}

export default PlantsList;
